import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import DeleteList from 'assets/images/Dashboard/delete.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPatientListData } from 'store/patientList/patientListAction';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import moment from 'moment';
import { deletePatientData } from 'store/patientListDelete/patientListDeleteAction';
import { patientsDetail } from 'routes/AppUrls';
import { ClearTokenRedirectLogin } from 'utils/general';
import ReusablePagination from 'components/commom/Pagination';
import {
  basicDetailsValue,
  PATIENT_ID,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import CommonToast from 'components/commom/CommonToast';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import { getSubscriptionListCallApi } from 'store/getSubscriptionList/action';
import { addSubscriptionPurchaseCallAPI } from 'store/addSubscriptionPurchase/action';
import SwitchList from 'components/commom/SwitchList';
import { getUpdateStatusValue } from 'store/providerStatus/providerStatusAction';
import LabelWithInput from 'components/commom/LabelWithInput';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from 'assets/images/android.png';

const PatientList = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const intl = useIntl();
  const [patientList, setPatientList] = useState([]);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [isModalActive, setIsModalActive] = useState(false);
  const [viewData, setViewData] = useState('');
  const [subscriptionPlan, setSubscriptionPlan] = useState('');
  const [durationPlanData, setDurationPlanData] = useState([]);
  const [durationPlan, setDurationPlan] = useState('');
  const [durationPlanId, setDurationPlanId] = useState('');
  const [contactModal, setContactModal] = useState(false);
  const [formData, setFormData] = useState({
    userFilter: 'App Only',
    search: '',
  });
  const itemsPerPage = 10;

  const loading = useSelector((state) => state?.patientListReducer?.loading);
  const subscriptionListLoader = useSelector(
    (state) => state?.getSubscriptionListReducer?.loading
  );
  const subscriptionListData = useSelector(
    (state) => state?.getSubscriptionListReducer?.users
  );

  const deleteLoading = useSelector(
    (state) => state?.deletepatientListReducer?.loading
  );

  const addSubscriptionPurchaseLoader = useSelector(
    (state) => state?.addSubscriptionPurchaseReducer?.loading
  );

  useEffect(() => {
    patientData(1, 'App Only', '');
  }, []);

  const patientData = (pageValue, data, search) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setPatientList(res?.data);
        setCount(Math.ceil(res?.count / itemsPerPage));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      getPatientListData(
        external,
        pageValue,
        data === 'Shopify Only'
          ? 'created_from_shopify=1'
          : data === 'App Only'
            ? 'created_from_app=1'
            : data === 'Guest Only'
              ? 'guest_user=1'
              : '',
        search ? `searchtext=${search}` : ''
      )
    );
  };

  const handlePatientDetail = (id) => {
    navigate(patientsDetail(locale));
    dispatch(basicDetailsValue(PATIENT_ID, id));
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDeleteId('');
  };

  const deletePatientListData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseDeleteModal();
        patientData();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deletePatientData(external, deleteId));
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    patientData(value, formData?.userFilter, formData?.search);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    patientData(1, formData?.userFilter, value);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.name,
    }));
    patientData(1, value?.name, formData?.search);
  };

  const userFilterData = [
    { id: 1, name: 'App Only' },
    { id: 2, name: 'Shopify Only' },
    { id: 3, name: 'Guest Only' },
    { id: 4, name: 'All' },
  ];

  const handleSubscriptionModal = (data) => {
    setSubscriptionPlan('');
    setViewData(data);
    const external = {
      run: true,
      handleFunction: () => setIsModalActive(true),
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSubscriptionListCallApi(external));
  };

  const handlePlanChange = (e) => {
    const { name, value } = e.target;
    if (name === 'subscriptionPlan') {
      setSubscriptionPlan(value?.name);
      setDurationPlanData(value?.sub_plans);
      if (value?.slug === 'freemium') {
        setDurationPlan(value?.name);
        setDurationPlanId(value?.slug);
      } else {
        setDurationPlan('');
        setDurationPlanId('');
      }
    }
    if (name === 'durationPlan') {
      setDurationPlan(value?.name);
      setDurationPlanId(value?.subscription_id);
    }
  };

  const handleSubscriptionPurchase = () => {
    const body = {
      userId: viewData?.id,
      data: {
        plan_id: durationPlanId,
      },
    };
    const external = {
      run: true,
      handleFunction: (res) => {
        setIsModalActive(false);
        patientData(page, formData?.userFilter, formData?.search);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(addSubscriptionPurchaseCallAPI(body, external));
  };

  let isRunning = false;
  const handleChange = (id) => {
    if (isRunning) return;
    isRunning = true;
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast('Successfully Updated', 'success');
        patientData(page, formData?.userFilter, formData?.search);
        isRunning = false;
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
        isRunning = false;
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
        isRunning = false;
      },
    };
    let body = {};
    dispatch(getUpdateStatusValue(external, id, body, '?payment_exemption=1'));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
              <FormattedMessage id="Patients" />
            </h2>
            {/* {!loading && patientList && patientList.length > 0 && (
              <Row className="m-0 p-0 ">
                <Col md={8} className="m-0 p-0 ">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center p-0"
                  >
                    <div className="fc-292D32 lh-201 family_outfit_medium_500">
                      Filter by:
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder="Select"
                        name={'userFilter'}
                        value={userFilter}
                        data={userFilterData}
                        onChange={(e) => handleInputChange(e)}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                  </Stack>
                </Col>
              </Row>
            )} */}
          </div>
          {
            <Row
              className="mt-3 mb-5 g-5"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </Col>
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  {'Filter by:'}
                </div>
                <div>
                  <SelectInputBorder
                    placeholder="Select"
                    name={'userFilter'}
                    value={formData?.userFilter}
                    data={userFilterData}
                    onChange={(e) => handleFilterChange(e)}
                    background={'#FFFFFF'}
                    colorIcon={'#292D32'}
                    placeholderColor={'#292D32'}
                  />
                </div>
              </Col>
            </Row>
          }
          {loading ? (
            <Loader />
          ) : patientList && patientList.length > 0 ? (
            <div className="pt-20">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col
                  lg={formData?.userFilter === 'App Only' ? 2 : 3}
                  md={6}
                  sm={12}
                >
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Patient & ID" />
                  </p>
                </Col>
                <Col
                  lg={formData?.userFilter === 'App Only' ? 1 : 2}
                  md={6}
                  sm={12}
                >
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Contact Info" />
                  </p>
                </Col>
                <Col
                  lg={formData?.userFilter === 'App Only' ? 1 : 2}
                  md={6}
                  sm={12}
                >
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Skin Analyser" />
                  </p>
                </Col>
                <Col
                  lg={formData?.userFilter === 'App Only' ? 1 : 2}
                  md={6}
                  sm={12}
                >
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Skin Concern Identifier" />
                  </p>
                </Col>
                <Col
                  lg={formData?.userFilter === 'App Only' ? 2 : 2}
                  md={6}
                  sm={12}
                >
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Joined On" />
                  </p>
                </Col>
                {formData?.userFilter === 'App Only' && (
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Current Plan" />
                    </p>
                  </Col>
                )}
                {formData?.userFilter === 'App Only' && (
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Subscription" />
                    </p>
                  </Col>
                )}
                {formData?.userFilter === 'App Only' && (
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Payment Exemption" />
                    </p>
                  </Col>
                )}
                {/* <Col
                  lg={formData?.userFilter === 'App Only' ? 2 : 3}
                  md={6}
                  sm={12}
                >
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Actions" />
                  </p>
                </Col> */}
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {patientList.map((item, index) => {
                  return (
                    <Row
                      className="m-0 p-0 flex items-center listAppointment"
                      // style={{
                      //   borderBottom: '1px solid #e5e5e5',
                      //   padding: ' 4px 8px !important',
                      //   backgroundColor: '#ffffff',
                      //   height: '110px',
                      // }}
                    >
                      <Col
                        lg={formData?.userFilter === 'App Only' ? 2 : 3}
                        md={6}
                        sm={12}
                        onClick={() => handlePatientDetail(item?.id)}
                        className="cursor-pointer"
                      >
                        <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                          {item?.patient_name}
                        </div>
                        <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                          {item?.patient_id}
                        </div>
                        {item?.device_info && (
                          <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center gap-2">
                            {item?.device_info?.device_type === 'ios' ? (
                              <AppleIcon
                                sx={{
                                  color: '#505050',
                                  width: '20px',
                                  height: '20px',
                                }}
                              />
                            ) : item?.device_info?.device_type === 'android' ? (
                              <Image src={AndroidIcon} alt="icon" />
                            ) : (
                              ''
                            )}
                            {/* {item?.device_info?.device_type || '-'} |  */}
                            App: {item?.device_info?.app_version || '-'} | OS:{' '}
                            {item?.device_info?.device_version || '-'}
                          </div>
                        )}
                      </Col>
                      <Col
                        lg={formData?.userFilter === 'App Only' ? 1 : 2}
                        md={6}
                        sm={12}
                        className="d-flex gap-3 cursor-pointer"
                        onClick={() => {
                          setContactModal(true);
                          setViewData(item);
                        }}
                      >
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center "
                        >
                          <Image src={mail} alt="icon" />
                          {/* <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                            {item?.patient_email}
                          </div> */}
                        </Stack>
                        {formData?.userFilter !== 'Guest Only' && (
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center pt-04"
                          >
                            <Image src={call} alt="icon" />
                            {/* <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                              {item?.patient_country_code} {item?.patient_phone}
                            </div> */}
                          </Stack>
                        )}
                      </Col>
                      <Col
                        lg={formData?.userFilter === 'App Only' ? 1 : 2}
                        md={6}
                        sm={12}
                      >
                        <p
                          className={`p-0 m-0 fs-14 family_outfit_regular_400 lh-176 ${item?.subscription_plan ? 'text-[#4497EA]' : 'fc-202224'}`}
                        >
                          {item?.subscription_plan
                            ? `${item?.subscription_plan?.used_haut_ai_scan} /${' '}
                          ${item?.subscription_plan?.available_haut_ai_scan}`
                            : `NA`}
                        </p>
                      </Col>
                      <Col
                        lg={formData?.userFilter === 'App Only' ? 1 : 2}
                        md={6}
                        sm={12}
                      >
                        <p
                          className={`p-0 m-0 fs-14 family_outfit_regular_400 lh-176 ${item?.subscription_plan ? 'text-[#4497EA]' : 'fc-202224'}`}
                        >
                          {item?.subscription_plan
                            ? `${item?.subscription_plan?.used_visualdx_scan} /${' '}
                          ${item?.subscription_plan?.available_visualdx_scan}`
                            : `NA`}
                        </p>
                      </Col>
                      <Col
                        lg={formData?.userFilter === 'App Only' ? 2 : 2}
                        md={6}
                        sm={12}
                      >
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {moment(item?.date_joined).format('DD MMM YYYY')}
                        </div>
                      </Col>
                      {formData?.userFilter === 'App Only' && (
                        <Col
                          lg={formData?.userFilter === 'App Only' ? 1 : 3}
                          md={6}
                          sm={12}
                        >
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {item?.subscription_plan
                              ? item?.subscription_plan?.subscription_plan_type
                                  ?.name
                              : 'NA'}
                          </div>
                        </Col>
                      )}
                      {formData?.userFilter === 'App Only' && (
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            <ReusableButton
                              fullWidth={false}
                              variant="outlined"
                              color="#3C3C3C"
                              fontSize="16px"
                              fontWeight="500"
                              padding="14px 24px"
                              borderRadius="0px"
                              height="44px"
                              bgColor="transparent"
                              brColor="#3C3C3C"
                              fontFamily="outfit_medium"
                              loading={
                                subscriptionListLoader &&
                                item?.id === viewData?.id
                              }
                              onClick={() =>
                                !subscriptionListLoader &&
                                handleSubscriptionModal(item)
                              }
                            >
                              Change Plan
                            </ReusableButton>
                          </div>
                        </Col>
                      )}
                      {formData?.userFilter === 'App Only' && (
                        <Col lg={1} md={6} sm={12}>
                          <SwitchList
                            checked={item?.payment_exemption}
                            onChange={(event) => handleChange(item?.id)}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        </Col>
                      )}
                      {/* <Col
                        lg={formData?.userFilter === 'App Only' ? 2 : 3}
                        md={6}
                        sm={12}
                      >
                        <Stack
                          direction="horizontal"
                          gap={1}
                          className="items-center cursor-pointer"
                        >
                          <div
                            className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                            onClick={() => handlePatientDetail(item?.id)}
                          >
                            <FormattedMessage id="View Details" />
                          </div>
                          <Image
                            src={ArrowRightIcon}
                            alt="icon"
                            onClick={() => handlePatientDetail(item?.id)}
                          />
                          <div className="pl-28">
                            <Image
                              src={DeleteList}
                              alt="icon"
                              onClick={() => handleDeleteModal(item?.id)}
                            />
                          </div>
                        </Stack>
                      </Col> */}
                    </Row>
                  );
                })}
              </Row>
            </div>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={deleteModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !deleteLoading && deletePatientListData();
                    }}
                    loading={deleteLoading}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      {/* contact modal */}
      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={contactModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Contact Details
                  </p>
                </div>
              </Col>
              <Col xs={12} className="mt-4">
                <Stack direction="horizontal" gap={2} className="items-center ">
                  <Image src={mail} alt="icon" />
                  <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                    {viewData?.patient_email}
                  </div>
                </Stack>
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center pt-04"
                >
                  <Image src={call} alt="icon" />
                  <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                    {viewData?.patient_country_code} {viewData?.patient_phone}
                  </div>
                </Stack>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  {/* <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => setContactModal(false)}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton> */}

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      setContactModal(false);
                    }}
                    loading={false}
                  >
                    OK
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
      {/* contact modal */}

      {/* subscription List  */}
      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModalActive}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Subscription
                  </p>
                </div>
                <div className="mt-[20px]">
                  <div className="flex items-center gap-[20px]">
                    <div className="fc-292D32 family_outfit_medium_500">
                      Plan:
                    </div>
                    <SelectInputBorder
                      placeholder="Select"
                      name={'subscriptionPlan'}
                      value={subscriptionPlan}
                      data={subscriptionListData?.data}
                      onChange={(e) => handlePlanChange(e)}
                      background={'#FFFFFF'}
                      width={'207px'}
                      colorIcon={'#292D32'}
                      placeholderColor={'#292D32'}
                    />
                  </div>
                  {subscriptionPlan && subscriptionPlan !== 'Freemium' && (
                    <div className="flex items-center gap-[20px] mt-[20px]">
                      <div className="fc-292D32 family_outfit_medium_500">
                        Duration:
                      </div>
                      <SelectInputBorder
                        placeholder="Select"
                        name={'durationPlan'}
                        value={durationPlan}
                        data={durationPlanData}
                        onChange={(e) => handlePlanChange(e)}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                  )}
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-5 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => setIsModalActive(false)}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !addSubscriptionPurchaseLoader &&
                        handleSubscriptionPurchase();
                    }}
                    loading={addSubscriptionPurchaseLoader}
                  >
                    <FormattedMessage id="Submit" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
      {/* subscription List  */}
    </div>
  );
};

export default PatientList;
